module.exports = __webpack_public_path__ + "img/制御工学4_5.eed3dab1.png";